import {takeUntil} from 'rxjs/operators';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

import { CutimedService } from './Cutimed.service';
import { CutimedWebShopCatalogApi } from '../../../api/product/tena/cutimed/CutimedWebShopCatalogApi';
import { ICutimedWebShopCatalog } from '../../../model/product/tena/cutimed/ICutimedWebShopCatalog';

@Component({
    selector: 'admin-cutimed-country-select',
    templateUrl: 'CutimedCountrySelect.component.html',
    providers: [CutimedWebShopCatalogApi]
})
export class CutimedCountrySelectComponent implements OnInit, OnDestroy {
    countryForm: FormGroup;
    countries: ICutimedWebShopCatalog[];

    @Input()
    selectedCountry: ICutimedWebShopCatalog;

    @Input()
    modalVisible: boolean;

    private unsubscribe: Subject<void> = new Subject();

    constructor(
        public cutimedService: CutimedService,
        private cutimedCatalogApi: CutimedWebShopCatalogApi,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.cutimedService.countries.pipe(
            takeUntil(this.unsubscribe))
            .subscribe((countries: ICutimedWebShopCatalog[]) => {
                this.countries = countries;
            });

        this.countryForm = this.fb.group({
            country: new FormControl(
                this.selectedCountry ? this.selectedCountry.objectId.toString() : '',
                Validators.required
            )
        });

        this.cutimedCatalogApi.getAll().subscribe((res: ICutimedWebShopCatalog[]) => {
            this.cutimedService.countries.next(res);
        });

        this.cutimedService.countryModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.toggleCountryModal(visible);
            });

        this.toggleCountryModal(this.modalVisible);
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    selectCountry(country: ICutimedWebShopCatalog) {
        if (this.countryForm.valid) {
            country = this.countries.find((item: ICutimedWebShopCatalog) => {
                if (item.objectId === parseInt(this.countryForm.value.country)) {
                    return true;
                }
            });
            window.sessionStorage.setItem('cutimedSelectedCountry', JSON.stringify(country));
            this.cutimedService.countryChanged.next(country);

            this.cutimedService.countryModalVisible.next(false);
        }
    }

    toggleCountryModal(show: boolean) {
        if (show) {
            document.getElementsByTagName('body')[0].className = 'modal-open';
        } else {
            document.getElementsByTagName('body')[0].classList.remove('modal-open');
        }
    }
}

